'use strict';

module.exports = Object.assign({}, require('./deserialize'), require('./serialize'));


//////////////////
// WEBPACK FOOTER
// ./~/json-immutable-ex/lib/index.js
// module id = 984
// module chunks = 0